module.exports = __webpack_public_path__ + "static/img/icn_file_3d.f207577.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/icn_file_3d.png
// module id = XSw+
// module chunks = 1